import classNames from "classnames";
import React from "react";
import { DEFAULT_FORM_FIELD_ATTRIBUTE } from "./constants";

export interface FormValidationFieldShellProps {
  name: string;
  required?: boolean;
  invalid?: boolean;
  children: React.ReactNode;
  fieldAttribute?: string;
  dataTestIdPrefix?: string;
  className?: string;
}

const FormValidationFieldShell: React.FC<FormValidationFieldShellProps> = ({
  name,
  required,
  invalid,
  children,
  fieldAttribute = DEFAULT_FORM_FIELD_ATTRIBUTE,
  dataTestIdPrefix = "form-field",
  className,
}) => {
  const fieldDataAttr = { [fieldAttribute]: name } as Record<string, string>;

  return (
    <div
      {...fieldDataAttr}
      className={classNames(
        "tlx-form-validation-field",
        required && "tlx-form-validation-field--required",
        invalid && "tlx-form-validation-field--invalid",
        className,
      )}
      data-test-id={`${dataTestIdPrefix}-${name}`}
      tabIndex={-1}
    >
      {children}
    </div>
  );
};

export default FormValidationFieldShell;
